import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      position: 'relative',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: `1px solid ${theme.palette.grey['300']}`,
      cursor: 'pointer',
      zIndex: 2,
    },
    selectedText: {
      color: theme.palette.text.primary,
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.text.secondary,
    },
    panel: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      background: '#fff',
      borderRadius: 4,
      boxShadow: '0px 2px 16px rgba(152, 169, 188, 0.2)',
    },
    item: {
      padding: theme.spacing(3, 2),
      transition: theme.transitions.create('background'),
      '&:hover': {
        background: theme.palette.grey[50],
      },
    },
  })
);
